module.exports = __webpack_public_path__ + "media/images/components/c03-welcome-helpline/image--lg-3e6b780a9552f296db2e76478d18ebde.svg";